// src/components/PasswordGate/PasswordGate.jsx
import { useState, useEffect } from 'react';
import './PasswordGate.css';

const PASSWORD = "judith2025"; // Cambia esto

export default function PasswordGate({ children }) {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('portfolio_unlocked') === 'true') {
      setIsUnlocked(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === PASSWORD) {
      setIsUnlocked(true);
      sessionStorage.setItem('portfolio_unlocked', 'true');
    } else {
      setError(true);
    }
  };

  if (isUnlocked) return children;

  return (
    <div className="password-gate">
      <form onSubmit={handleSubmit}>
        <h2> Judith Matute Portfolio </h2>
        <input
          type="password"
          value={input}
          onChange={(e) => { setInput(e.target.value); setError(false); }}
          placeholder="Enter the password"
        />
        <button type="submit">Enter</button>
        {error && <p className="error">Wrong password</p>}
      </form>
    </div>
  );
}